import { useState } from 'react'
import { Box, IconButton } from '@mui/material'
import {
    DesignServices as DesignServicesIcon,
    People as PeopleIcon
} from '@mui/icons-material'
import { ReactQueryDevtools } from 'react-query/devtools'

import { PatientEngagementDialog } from './PatientEngagementDialog'
import { useNavigation } from 'src/hooks'

export const DevTools = () => {
    const { navigate } = useNavigation()
    const [devtoolsDialogOpen, setPatientEngagementDialogOpen] = useState(false)

    const handlePatientEngagementClose = () => {
        setPatientEngagementDialogOpen(false)
    }

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 4,
                    zIndex: 5000
                }}
            >
                <ReactQueryDevtools />
                <Box sx={{ ml: 8, mb: '8px' }}>
                    <IconButton
                        onClick={() => setPatientEngagementDialogOpen(true)}
                    >
                        <PeopleIcon
                            sx={{ color: 'var(--mui-palette-text-primary)' }}
                        />
                    </IconButton>
                    <IconButton onClick={() => navigate('/mui/library')}>
                        <DesignServicesIcon
                            sx={{ color: 'var(--mui-palette-text-primary)' }}
                        />
                    </IconButton>
                </Box>
            </Box>
            <PatientEngagementDialog
                open={devtoolsDialogOpen}
                onClose={handlePatientEngagementClose}
            />
        </>
    )
}

export default DevTools
